import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';
import { trackShowSilhouette } from 'site-modules/shared/utils/inventory/tracking';
import { TrackingConstant } from 'client/tracking/constant';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';

function InventoryThumbnailImageComponent(props) {
  const { url, vin, bodyType } = props;

  const handleError = useCallback(() => {
    trackShowSilhouette(TrackingConstant.SHOW_SILHOUETTE_ERROR, vin, url);
  }, [vin, url]);

  return (
    <Image
      className="h-100 w-100"
      errorImage={getNoVehicleImageToDisplay(bodyType)}
      alt=""
      imageId={url}
      source={SOURCES.EDMUNDSCDNASSETS}
      onError={handleError}
      lazy
    />
  );
}

InventoryThumbnailImageComponent.propTypes = {
  url: PropTypes.string.isRequired,
  vin: PropTypes.string.isRequired,
  bodyType: PropTypes.string.isRequired,
};

export const InventoryThumbnailImage = memo(InventoryThumbnailImageComponent);
